import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';

export default class CaspianXXQueryProcessingHistorySearchParams extends SearchParamsBase {
  initialize() {
    this.Id = '';
    this.Type = '';
    this.RealQuery = '';
    this.UseDateRange = false;
    this.StartDate = dateTimeHelper.addDaysToDate(new Date(), -4);
    this.EndDate = dateTimeHelper.indefiniteDateValue();
  }

  //-------------------------------------------
  //-------- Fields for Search Panel ----------
  //-------------------------------------------

  static fieldsInSearchBox = [
    { fieldName: 'Id', label: 'Id', className: 'col-6', type: InputTypesEnum.Number },
    { fieldName: 'Type', label: 'Type', className: 'col-6', type: InputTypesEnum.Text },
    { fieldName: 'RealQuery', label: 'RealQuery', className: 'col-12', type: InputTypesEnum.Text },
    { fieldName: 'UseDateRange', label: 'Use Date Range', className: 'col-6', type: InputTypesEnum.OnOff },
    {
      fieldName: 'StartDate',
      label: 'Start Date',
      className: 'col-6',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
    {
      fieldName: 'EndDate',
      label: 'End Date',
      className: 'col-6',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (searchItem) => searchItem.UseDateRange,
    },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'CaspianXXQueryProcessingHistorySearchParams';
  static maxWidth = 1200;

  //---------------------------
}
